import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, unref as _unref, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-33028983"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "entity-detail el-card"
}
const _hoisted_2 = { class: "entity-detail__head" }
const _hoisted_3 = { class: "entity-detail__title" }
const _hoisted_4 = ["title"]
const _hoisted_5 = { class: "collapse-title" }
const _hoisted_6 = { class: "entity-detail__list" }
const _hoisted_7 = { class: "label cm-ui-mr10" }
const _hoisted_8 = ["title"]
const _hoisted_9 = {
  key: 0,
  class: "cm-ellipsis-line-one"
}
const _hoisted_10 = {
  key: 1,
  class: "entity-detail__text-value"
}
const _hoisted_11 = {
  key: 2,
  class: "entity-detail__text-value"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-download",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_13 = { class: "collapse-title" }
const _hoisted_14 = { class: "entity-detail__list" }
const _hoisted_15 = { class: "label" }
const _hoisted_16 = { class: "value" }
const _hoisted_17 = { class: "label" }
const _hoisted_18 = { class: "value" }
const _hoisted_19 = { class: "label" }
const _hoisted_20 = { class: "value" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "label" }
const _hoisted_23 = { class: "value" }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "label" }
const _hoisted_26 = { class: "value" }
const _hoisted_27 = { key: 2 }
const _hoisted_28 = { class: "label" }
const _hoisted_29 = { class: "value" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "ATT&CK", -1))
const _hoisted_31 = { class: "value cm-align-center" }
const _hoisted_32 = { key: 0 }

import { ref, computed, watch, nextTick } from 'vue'
import { useI18n } from 'vue-i18n'
import dayjs from 'dayjs'
import { formatTimeStamp } from '@/utils/time'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { listCol } from '@/utils/list-columns-i18n'
import { bytesToSize } from '@/utils/tool'
import Copy from '@/views/_components/copy/copy.vue'
import EllipsisText from '@/views/dashboard/_components/ellipsis-text/ellipsis-text.vue'
import EmptyData from '@/views/dashboard/_components/empty-data/empty-data.vue'
import { HawkEyeQueryService } from '../hawk-eye-query.service'
import type { HawkThreatInfo } from '../hawk-eye-query.service'
import { SecurityEventService } from '../security-event.service'
import type { SimpleResponseData } from '../security-event.service'
import type { ProcessChainNode, SafeEventDetailApiResponse } from '../types'
import ProcessChainGraph from './process-chain-graph.vue'
import { PROCESS_CHAIN_ICON } from './process-chain-icons'
import { getAttackTacticName } from '../attack-tactic-map'
import { trEventTypeDisplay, trListEventLevel, listLevelColor, trEventDesc } from '../labels'
import { PARSE_STATUS_COLOR_MAP, mapProcessChainFromSdk } from '../security-event-detail.mapper'

type DetailRow = {
  label: string
  value: string
  type?: 'text' | 'md5' | 'tag' | 'script' | 'copy'
  /** 标签类型时的背景色（使用 StatusColor 映射） */
  tagColor?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'process-chain-panel',
  props: {
    nodes: {},
    hawkMd5: {},
    assetIp: {},
    computer_name: {},
    fullscreen: { type: Boolean },
    eventType: {},
    eventDesc: {},
    hitAttackStages: {},
    alarmCount: {},
    firstAlarmTime: {},
    lastAlarmTime: {},
    eventLevel: {},
    listRowBusinessId: {},
    deviceId: {}
  },
  setup(__props: any) {

const props = __props

const { t } = useI18n()

const graphRef = ref<{ refreshGraph: (nodes?: ProcessChainNode[]) => void } | null>(null)

function displayText (value?: string) {
  if (!value) return ''
  return value.startsWith('securityEvent.') ? t(value) : value
}

const injector = useReflectiveInjector([HawkEyeQueryService, SecurityEventService])
const hawkService = injector.get(HawkEyeQueryService)
const securityEventService = injector.get(SecurityEventService)

const selected = ref<ProcessChainNode | null>(null)
const displayNodes = ref<ProcessChainNode[]>([...props.nodes])
const moreLoading = ref(false)
const hawkInfo = ref<HawkThreatInfo | null>(null)
const hawkLoading = ref(false)
const simpleDetail = ref<SimpleResponseData | SafeEventDetailApiResponse | null>(null)
const simpleLoading = ref(false)
const activeCollapseNames = ref(['basic', 'alert'])

const queryMd5 = computed(() => selected.value?.md5 || props.hawkMd5 || '')

function entityIconUrl (node?: ProcessChainNode | null) {
  if (!node) return PROCESS_CHAIN_ICON.default
  return PROCESS_CHAIN_ICON.object(node.object_type)
}

const selectedIconStyle = computed(() => {
  const url = entityIconUrl(selected.value)
  return {
    WebkitMaskImage: `url(${url})`,
    maskImage: `url(${url})`,
  }
})

const nodeRoleLabel = (nodeType?: number) => {
  if (nodeType === 2) return t('securityEvent.roleInitiator')
  if (nodeType === 3) return t('securityEvent.roleTarget')
  return ''
}

const attackStageNames = computed(() => {
  const tactic = simpleDetail.value?.attack_tactic
  if (tactic) {
    const name = getAttackTacticName(tactic, t)
    return name ? [name] : [tactic]
  }
  if (!props.hitAttackStages?.length) return []
  return props.hitAttackStages.map((id) => getAttackTacticName(id, t) || id)
})

const entityTags = computed(() => {
  const tags: string[] = []
  const s = selected.value
  if (!s) return tags
  const roleLabel = nodeRoleLabel(s.node_type)
  if (roleLabel) tags.push(roleLabel)
  if (s.threat_type) tags.push(s.threat_type)
  if (hawkInfo.value?.threat_type) tags.push(hawkInfo.value.threat_type)
  return [...new Set(tags)]
})

const DETAIL_TAG_KEYS = new Set([
  'signature_valid',
  'scan_result',
  'network_direction',
  'fieldSignatureValid',
  'fieldCloudStatus',
])

function fieldKeyFromLabelKey (labelKey: string) {
  return labelKey.split('.').pop() || labelKey
}

function isMd5Field (fieldKey: string, label: string) {
  return /md5/i.test(fieldKey) || /^md5$/i.test(label)
}

/** 脚本内容字段（10xx 系列 + scriptcontent） */
function isScriptField (fieldKey: string) {
  return /^(10\d{2})$/.test(fieldKey) || fieldKey === 'scriptcontent'
}

function isTimeField (fieldKey: string) {
  return /(^|_)time$|time_i64|creation_time|start_time|end_time|pe_time/i.test(fieldKey)
}

function isFileSizeField (fieldKey: string) {
  return /(^|_)file_size$|dump_size|fieldFileSize/i.test(fieldKey)
}

function isEmptyValue (value: unknown) {
  return value === undefined || value === null || value === '' || value === false
}

function formatFileSizeValue (value: string) {
  const n = Number(value)
  if (!Number.isFinite(n)) return value
  return bytesToSize(n)
}

function formatDetailTime (value: string) {
  if (/^\d{10}$/.test(value)) return dayjs(Number(value) * 1000).format('YYYY-MM-DD HH:mm:ss')
  if (/^\d{13}$/.test(value)) return dayjs(Number(value)).format('YYYY-MM-DD HH:mm:ss')
  const parsed = dayjs(value)
  if (parsed.isValid()) return parsed.format('YYYY-MM-DD HH:mm:ss')
  return value
}

function translateLabel (labelKey: string) {
  return labelKey.startsWith('securityEvent.') ? t(labelKey) : labelKey
}

function stringifyValue (value: unknown) {
  if (isEmptyValue(value)) return '--'
  if (typeof value === 'string' && (value.startsWith('securityEvent.') || value.startsWith('ipAddressBlocking.') || value.startsWith('parseStatus.'))) return t(value)
  if (Array.isArray(value)) return value.join(', ')
  return String(value)
}

function isDomainOrHostnameField (fieldKey: string) {
  return /dns_domain|hostname/i.test(fieldKey)
}

function formatDetailValue (fieldKey: string, value: unknown) {
  let val = stringifyValue(value)
  if (isEmptyValue(val)) val = '--'
  if (val === '--') return val
  if (isTimeField(fieldKey)) return formatDetailTime(val)
  if (isFileSizeField(fieldKey)) return formatFileSizeValue(val)
  if (isDomainOrHostnameField(fieldKey)) return `https://${val}`
  return val
}

/** 命令行 / 路径相关字段：需要复制功能 */
function isCopyTextField (fieldKey: string, label: string) {
  return /command|command_?line|cmd_?line|cmdline/i.test(fieldKey) ||
    /file_?path|filepath|_path$|^path$/i.test(fieldKey) ||
    /url$/i.test(fieldKey) ||
    /命令行|路径|URL|コマンド|パス/i.test(label)
}

function detailRowType (fieldKey: string, label: string): DetailRow['type'] {
  if (isMd5Field(fieldKey, label)) return 'md5'
  if (isScriptField(fieldKey)) return 'script'
  if (isCopyTextField(fieldKey, label)) return 'copy'
  if (DETAIL_TAG_KEYS.has(fieldKey)) return 'tag'
  return 'text'
}

function createDetailRow (labelKey: string, value: unknown): DetailRow {
  const fieldKey = fieldKeyFromLabelKey(labelKey)
  const label = translateLabel(labelKey)
  const type = detailRowType(fieldKey, label)
  const row: DetailRow = {
    label,
    value: formatDetailValue(fieldKey, value),
    type,
  }
  // 标签类型：根据原始 i18n key 查找对应颜色
  if (type === 'tag' && typeof value === 'string') {
    row.tagColor = PARSE_STATUS_COLOR_MAP[value] || PARSE_STATUS_COLOR_MAP['parseStatus.unknownInfo']
  }
  return row
}

function fallbackDetailRows (s: ProcessChainNode): DetailRow[] {
  return [
    createDetailRow('PID', s.pid != null ? String(s.pid) : '--'),
    createDetailRow('securityEvent.fieldCommandLine', s.command_line || '--'),
    createDetailRow(listCol(t, 'filePath'), s.path || '--'),
    createDetailRow('MD5', s.md5 || props.hawkMd5 || '--'),
    createDetailRow('securityEvent.fieldSignatureValid', s.signature_valid || '--'),
    createDetailRow('securityEvent.fieldSignature', s.signature || '--'),
    createDetailRow('securityEvent.fieldCloudStatus', s.cloud_status || '--'),
    createDetailRow('securityEvent.fieldVirusName', hawkInfo.value?.threat_type || s.threat_type || '--'),
    createDetailRow('securityEvent.fieldCreateTime', s.create_time || '--'),
    createDetailRow('securityEvent.fieldFileSize', s.file_size ?? '--'),
    createDetailRow('securityEvent.fieldUsername', s.username || '--'),
    createDetailRow('securityEvent.fieldBehavior', s.behavior || hawkInfo.value?.description || '--'),
  ]
}

function formatRawFields (rawFields: Record<string, unknown>, rows: DetailRow[]): DetailRow[] {
  const URL_KEY = 'securityEvent.objField.url'
  const HOST_KEY = 'securityEvent.objField.name'

  const rawUrl = rawFields[URL_KEY]
  const rawHost = rawFields[HOST_KEY]
  if (rawUrl && rawHost) {
    const host = String(rawHost).replace(/^https?:\/\//, '').replace(/\/$/, '')
    const path = String(rawUrl).replace(/^https?:\/\/[^/]+/, '')
    const combined = `${host}${path.startsWith('/') ? path : `/${path}`}`
    const urlRow = rows.find(r => r.label === t(URL_KEY))
    if (urlRow) urlRow.value = combined
  }

  return rows
}

const detailRows = computed<DetailRow[]>(() => {
  const s = selected.value
  if (!s) return []
  const rawFields = s.raw_fields || {}
  const rawRows = Object.entries(rawFields).map(([labelKey, value]) => createDetailRow(labelKey, value))
  const rows = rawRows.length ? rawRows : fallbackDetailRows(s)
  return formatRawFields(rawFields, rows)
})

watch(
  () => props.nodes,
  (list) => {
    // 优先通过 business_id 匹配列表行的 business_id 查找默认高亮节点
    let defaultSelected: ProcessChainNode | null = null
    if (props.listRowBusinessId) {
      defaultSelected = list.find((n) => n.business_id === props.listRowBusinessId) ?? null
    }
    // 其次通过 is_threat/ is_threat_entity 查找
    if (!defaultSelected) {
      defaultSelected = list.find((n) => n.is_threat_entity === 1) ?? list.find((n) => n.is_threat) ?? null
    }
    selected.value = defaultSelected ?? list[0] ?? null
    hawkInfo.value = null
    simpleDetail.value = null
  },
  { immediate: true }
)

// 选中节点变化时，若为告警节点（node_type === 3）则请求告警详情
watch(
  () => selected.value,
  (node) => {
    simpleDetail.value = null
    if (node?.node_type === 3 && node?.business_id) {
      fetchSimpleDetail(node.business_id)
    }
  }
)

// 外部 nodes 变化时同步显示节点（仅监听引用变化，不加 deep，避免内部 top 修改触发回写覆盖）
watch(
  () => props.nodes,
  (list) => {
    displayNodes.value = [...list]
    void nextTick(() => graphRef.value?.refreshGraph(displayNodes.value))
  }
)

function tagType (tag: string): 'primary' | 'success' | 'warning' | 'danger' | 'info' {
  if (/木马|病毒|trojan|virus/i.test(tag)) return 'danger'
  if (/可疑|suspicious/i.test(tag)) return 'warning'
  return 'primary'
}

function onNodeClick (node: ProcessChainNode) {
  selected.value = node
  hawkInfo.value = null
  simpleDetail.value = null
}

async function onNodeMoreClick (node: ProcessChainNode) {
  moreLoading.value = true
  // await 前暂存 node 的关键属性，避免后续引用被 watch 重置
  const nodeId = node.id
  const top = node.top

  try {
    if (![1, 3].includes(top ?? 0)) return

    const res = await securityEventService.getSafeeventExpandProcessChain({
      device_id: props.deviceId,
      process_guid: String(nodeId),
      max_level: 1,
      top,
    })

    if (!res.process_chain?.length) return

    // 映射新节点
    const mapped = mapProcessChainFromSdk(undefined, [], undefined, res.process_chain)

    // 过滤掉 mapped 中已在 displayNodes 中存在的节点（API 返回的上级链通常包含点击节点自身）
    const existingIds = new Set(displayNodes.value.map(n => n.id))
    const newNodes = mapped.filter(item => !existingIds.has(item.id))

    // 点击节点保留，将其 top 置为 2 隐藏"更多"按钮
    const clickedIdx = displayNodes.value.findIndex(item => item.id === nodeId)
    if (clickedIdx !== -1) {
      displayNodes.value[clickedIdx].top = 2
    }

    if (top === 3) {
      // 有下级节点：子节点追加到末尾
      displayNodes.value = [...displayNodes.value, ...newNodes]
    } else if (top === 1) {
      // 有上级节点：父节点前置
      displayNodes.value = [...newNodes, ...displayNodes.value]
    } else {
      displayNodes.value = [...displayNodes.value, ...newNodes]
    }

    // 命令式刷新图，直接传入最新数据，避免 props 时序问题
    void nextTick(() => graphRef.value?.refreshGraph(displayNodes.value))
  } catch (e) {
    console.error('[ProcessChain] 展开进程链失败', e)
  } finally {
    moreLoading.value = false
  }
}
async function fetchSimpleDetail (businessId: string) {
  if (!businessId) return
  simpleLoading.value = true
  simpleDetail.value = await securityEventService.getSafeEventDetail({ business_id: businessId })
  simpleLoading.value = false
}

/** 鼠标右键点击行 → 打开新标签页下载脚本 */
function downloadScript () {
  const url = selected.value?.download_url
  if (!url) return
  window.open(url, '_blank')
}

/** 当前选中节点是否为脚本内容行且具有下载地址 */
const hasDownloadUrl = computed(() => !!selected.value?.download_url)

async function queryHawk () {
  const md5 = queryMd5.value
  if (!md5) return
  hawkLoading.value = true
  hawkInfo.value = await hawkService.queryByHash(md5)
  hawkLoading.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_row = _resolveComponent("el-row")!
  const _directive_intel_link = _resolveDirective("intel-link")!

  return (_openBlock(), _createBlock(_component_el_row, {
    gutter: 16,
    class: _normalizeClass(["process-chain-panel", { 'is-fullscreen': _ctx.fullscreen }])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_col, {
        span: 18,
        class: "process-chain-panel__graph-col"
      }, {
        default: _withCtx(() => [
          (displayNodes.value.length)
            ? (_openBlock(), _createBlock(ProcessChainGraph, {
                key: 0,
                ref_key: "graphRef",
                ref: graphRef,
                nodes: displayNodes.value,
                computer_name: _ctx.computer_name,
                "selected-id": selected.value?.id,
                "asset-ip": _ctx.assetIp,
                fullscreen: _ctx.fullscreen,
                "event-level": _ctx.eventLevel,
                "matched-business-id": _ctx.listRowBusinessId,
                onNodeClick: onNodeClick,
                onNodeMoreClick: onNodeMoreClick
              }, null, 8, ["nodes", "computer_name", "selected-id", "asset-ip", "fullscreen", "event-level", "matched-business-id"]))
            : (_openBlock(), _createBlock(EmptyData, {
                key: 1,
                height: "360px"
              }))
        ]),
        _: 1
      }),
      _createVNode(_component_el_col, {
        span: 6,
        class: "process-chain-panel__detail-col"
      }, {
        default: _withCtx(() => [
          (selected.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("span", {
                      class: "entity-detail__icon",
                      style: _normalizeStyle(selectedIconStyle.value)
                    }, null, 4),
                    _createElementVNode("span", {
                      class: "entity-detail__name",
                      title: displayText(selected.value.name)
                    }, _toDisplayString(displayText(selected.value.name)), 9, _hoisted_4)
                  ]),
                  (selected.value.is_threat_entity === 1)
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 0,
                        type: "danger",
                        size: "mini",
                        effect: "plain",
                        class: "entity-detail__tag security-event-tag"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('securityEvent.colThreatEntity')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entityTags.value, (tag) => {
                    return (_openBlock(), _createBlock(_component_el_tag, {
                      key: tag,
                      size: "small",
                      type: tagType(tag),
                      effect: "plain",
                      class: "entity-detail__tag security-event-tag"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(tag), 1)
                      ]),
                      _: 2
                    }, 1032, ["type"]))
                  }), 128))
                ]),
                _createVNode(_component_el_collapse, {
                  modelValue: activeCollapseNames.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeCollapseNames).value = $event)),
                  class: "entity-detail__collapse"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_collapse_item, { name: "basic" }, {
                      title: _withCtx(() => [
                        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('securityEvent.sectionBasicInfo')), 1)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("ul", _hoisted_6, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailRows.value, (row) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: row.label
                            }, [
                              _createElementVNode("span", _hoisted_7, _toDisplayString(row.label), 1),
                              _createElementVNode("div", {
                                class: "value",
                                title: row.value,
                                style: {"position":"relative"}
                              }, [
                                (row.type === 'md5' || row.type === 'copy')
                                  ? (_openBlock(), _createBlock(Copy, {
                                      key: 0,
                                      reverse: "",
                                      content: row.value,
                                      class: "entity-detail__copy"
                                    }, {
                                      default: _withCtx(() => [
                                        (row.type === 'md5')
                                          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_9, null, 512)), [
                                              [_directive_intel_link, row.value]
                                            ])
                                          : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(row.value), 1))
                                      ]),
                                      _: 2
                                    }, 1032, ["content"]))
                                  : (row.type === 'tag')
                                    ? (_openBlock(), _createBlock(_component_el_tag, {
                                        key: 1,
                                        size: "small",
                                        style: _normalizeStyle(`background-color: ${row.tagColor}1a;border: 1px solid ${row.tagColor};color:${row.tagColor}`)
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(row.value), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["style"]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(row.value), 1)),
                                (row.type === 'script' && hasDownloadUrl.value)
                                  ? (_openBlock(), _createBlock(_component_el_button, {
                                      key: 3,
                                      type: "text",
                                      size: "mini",
                                      onClick: downloadScript
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_12,
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('securityEvent.download')), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ], 8, _hoisted_8)
                            ]))
                          }), 128))
                        ])
                      ]),
                      _: 1
                    }),
                    (selected.value.node_type === 3)
                      ? (_openBlock(), _createBlock(_component_el_collapse_item, {
                          key: 0,
                          name: "alert"
                        }, {
                          title: _withCtx(() => [
                            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('securityEvent.sectionAlertInfo')), 1)
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("ul", _hoisted_14, [
                              _createElementVNode("li", null, [
                                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('securityEvent.colLevel')), 1),
                                _createElementVNode("span", _hoisted_16, [
                                  _createVNode(_component_el_tag, {
                                    size: "small",
                                    type: _unref(listLevelColor)(simpleDetail.value?.event_level)
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(trListEventLevel)(_unref(t), simpleDetail.value?.event_level)), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["type"])
                                ])
                              ]),
                              _createElementVNode("li", null, [
                                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('securityEvent.colEventType')), 1),
                                _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(trEventTypeDisplay)(_unref(t), simpleDetail.value ?? undefined)), 1)
                              ]),
                              _createElementVNode("li", null, [
                                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('securityEvent.colDescription')), 1),
                                _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(trEventDesc)(_unref(t), simpleDetail.value?.event_id)), 1)
                              ]),
                              (simpleDetail.value?.alarm_count != null || props.alarmCount != null)
                                ? (_openBlock(), _createElementBlock("li", _hoisted_21, [
                                    _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('securityEvent.colAlertCount')), 1),
                                    _createElementVNode("span", _hoisted_23, _toDisplayString(simpleDetail.value?.alarm_count) + _toDisplayString(_ctx.$t('securityEvent.alertCountUnit')), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (simpleDetail.value?.first_alarm_time || props.firstAlarmTime)
                                ? (_openBlock(), _createElementBlock("li", _hoisted_24, [
                                    _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('securityEvent.colFirstAlert')), 1),
                                    _createElementVNode("span", _hoisted_26, _toDisplayString(_unref(formatTimeStamp)(simpleDetail.value?.first_alarm_time)), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (simpleDetail.value?.last_alarm_time || props.lastAlarmTime)
                                ? (_openBlock(), _createElementBlock("li", _hoisted_27, [
                                    _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t('securityEvent.colLastAlert')), 1),
                                    _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(formatTimeStamp)(simpleDetail.value?.last_alarm_time)), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("li", null, [
                                _hoisted_30,
                                _createElementVNode("div", _hoisted_31, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attackStageNames.value, (stage) => {
                                    return (_openBlock(), _createBlock(_component_el_tag, {
                                      key: stage,
                                      size: "small",
                                      type: "danger",
                                      effect: "plain",
                                      class: "entity-detail__value-tag cm-ui-mr4"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(stage), 1)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128)),
                                  (!attackStageNames.value.length)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_32, "--"))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]))
            : (_openBlock(), _createBlock(EmptyData, {
                key: 1,
                height: "200px"
              }))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})